import { Modal } from "antd";
import closeIcon from "assets/images/CloseIcon.svg";
import CommonCheckBox from "component/common/CheckBox/CommonCheckBox";
import FormErrorMessage from "component/common/ErrorMessage";
import InputBox from "component/common/InputBox/InputBox";
import NormalMultiSelect from "component/common/NormalMultiSelect";
import moment from "moment";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { MSMERegistration } from "service/customer";
import { Toast } from "service/toast";
import CommonDatePicker from "../CommonDatePicker/CommonDatePicker";
import CustomController from "../Controller";
import { UploadLoader } from "../Loader";
import NormalButton from "../NormalButton/NormalButton";
import "./style.scss";

export default function MsmeDeclarationModal({
  name,
  isopen,
  onCancel,
  setMSMEregistrationview,
  MSMEregistrationview,
  setMSMEregistration,
  setmsmemodal = () => { },
  setFilesId = () => { },
}) {
  const statusOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];
  const [selected, setSelected] = useState(["Micro", "Small", "Medium"]); // Initialize all items as selected
  const [nonStriked, setNonStriked] = useState(["Micro", "Small", "Medium"]);
  const [loading, setLoading] = useState(false);

  const [msemscomapnay, setmsemscomapnay] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [inputfield, setinputfield] = useState({
    registerNumber: "",
    registerDate: moment().format("MM-DD-YYYY"),
  });

  const [isCheckedtwo, setIsCheckedtwo] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset, control
  } = useForm({
    mode: "all",
  });

  useEffect(() => {
    setinputfield({ registerNumber: "", registerDate: "" });
    setIsCheckedtwo(false);
    setIsChecked(false);
    setmsemscomapnay("");
    reset();
  }, [MSMEregistrationview]);

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setinputfield({
  //     ...inputfield,
  //     [name]: value,
  //   });
  // };

  const handleChange = (name, value) => {
    setinputfield({
      ...inputfield,
      [name]: value,
    });
  };

  const handleCheckBoxChange = (event) => {
    setIsChecked(event.target.checked);
    setValue("agree", event.target.checked);
  };

  const handleCheckBoxChangetwo = (event) => {
    setIsCheckedtwo(event.target.checked);
    setValue("agreetwo", event.target.checked);
  };

  const handleButtonClick = () => {
    if (msemscomapnay == "yes") {
      if (nonStriked?.length == 1) {
        onsubmit();
      } else {
        Toast({
          type: "error",
          message:
            "Please strike out the types of enterprises that are not applicable to your registration",
        });
      }
    } else {
      onsubmit();
    }
  };

  // Initialize all items as non-striked

  const handleClick = (type) => {
    setSelected((prevSelected) => {
      if (prevSelected.includes(type) && prevSelected.length === 1) {
        return prevSelected; // Prevent the last remaining item from being deselected
      }

      let newSelected;
      if (prevSelected.includes(type)) {
        newSelected = prevSelected.filter((item) => item !== type);
      } else {
        newSelected = [...prevSelected, type];
      }
      return newSelected;
    });
  };
  const isStriked = (type) => !selected.includes(type);

  useEffect(() => {
    const updatedNonStriked = ["Micro", "Small", "Medium"].filter(
      (item) => !isStriked(item)
    );
    setNonStriked(updatedNonStriked);
  }, [selected]);

  const onsubmit = async () => {
    setLoading(true);
    try {
      let body = {
        companyStatus: msemscomapnay == "yes" ? "REGISTERED" : "UNREGISTERED",
        isRegistered: msemscomapnay == "yes" ? true : false,
        consititutionOfEntity: name ? name : "",
        registerNumber: inputfield?.registerNumber,
        registerDate: inputfield?.registerDate,
        enterPrisesLevel: nonStriked[0],
        // refNo: "1254",
        date: moment().format("MMMM Do YYYY"),
      };
      const response = await MSMERegistration(body);

      if (response?.status === 200) {
        setLoading(false);
        setMSMEregistration(response.data.data);
        setMSMEregistrationview(false);
        setmsemscomapnay("");

        setFilesId({ uploadMSMEregistration: response.data.data });

        Toast({ type: "success", message: response.data.message });
        setmsmemodal(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      Toast({ type: "error", message: "error" });
      setmsmemodal(false);
    }
  };

  return (
    <>
      <Modal
        open={isopen}
        onCancel={onCancel}
        closable={false}
        footer={null}
        // centered
        width={600}
        className="p-md-5"
      >
        <div className="modal-header d-flex align-items-center justify-content-between p-3">
          <p className="m-0">Msme Declaration</p>
          <img
            onClick={onCancel}
            src={closeIcon}
            alt="Close"
            className="drawer-close-img"
          />
        </div>

        <div className="m-md-3 p-3 mb-5">
          {/* <p>Ref No : - </p> */}
          <p>Date : {moment().format("MMMM Do YYYY")} </p>
          <address>
            To,
            <br />
            DigiGrain Solutions Private Limited
            <br />
            5th Floor,JVP Building
            <br />
            Inorbit mall road,Madhapur
            <br />
            Hyderabad -500081
          </address>

          <div className="col-8 mt-2 ">
            <label className="fw-bold">
              {" "}
              {msemscomapnay
                ? "Are you a registered company under MSME act ?"
                : "Are You Registered company ? "}{" "}
            </label>
            <NormalMultiSelect
              placeholder={"Select"}
              options={statusOptions}
              name="filter"
              value={msemscomapnay}
              handleChange={(e, { value } = {}) => {
                setmsemscomapnay(value);
              }}
            />
            {msemscomapnay.length <= 0 ? (
              <>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </>
            ) : (
              ""
            )}
          </div>
          {msemscomapnay ? (
            <>
              <p className="mt-2">Dear sir ,</p>

              <p>we hereby confirm that : </p>

              {msemscomapnay == "yes" ? (
                <div>
                  <div className="col-12">
                    <div className="d-flex ">
                      <div className="mb-5 me-4">
                        <CommonCheckBox
                          isChecked={isChecked}
                          name="agree"
                          onChange={handleCheckBoxChange}
                          errors={errors}
                          register={register("agree", {
                            required: isChecked ? false : true,
                          })}
                        />
                        {!isChecked && (
                          // <div className='pe-5'>
                          <FormErrorMessage
                            error={errors?.agree}
                            className="msme_required_error"
                            messages={{
                              required: "*Required",
                            }}
                          />
                          // </div>
                        )}
                      </div>
                      <p className=" px-2">
                        I/We (<span className="fw-bold text-dark">{name}</span>{" "}
                        )are registered as a{" "}
                        <span
                          className={
                            isStriked("Micro") ? "strikethrough" : "fw-light"
                          }
                          onClick={() => handleClick("Micro")}
                        >
                          Micro{" "}
                        </span>{" "}
                        /{" "}
                        <span
                          className={
                            isStriked("Small") ? "strikethrough" : "fw-light"
                          }
                          onClick={() => handleClick("Small")}
                        >
                          {" "}
                          Small
                        </span>{" "}
                        /
                        <span
                          className={
                            isStriked("Medium") ? "strikethrough" : "fw-light"
                          }
                          onClick={() => handleClick("Medium")}
                        >
                          &nbsp;Medium
                        </span>
                        &nbsp; Enterprises (Strike out which is not applicable) under
                        the Micro, Small, medium Enterprises Development Act,
                        2006 and our registration number is
                        <InputBox
                          name="registerNumber"
                          value={inputfield.registerNumber}
                          onChange={handleChange}
                          register={register("registerNumber", {
                            required: true,
                          })}
                          placeholder="Please Enter here"
                        />
                        <FormErrorMessage
                          error={errors?.registerNumber}
                          className="msme_required_num_error"
                          messages={{
                            required: "Register Number is Required",
                          }}
                        />
                        <br />
                        {/* Date : */}
                        {/* <InputBox
                          type="date"
                          name="registerDate"
                          value={inputfield.registerDate}
                          onChange={handleChange}
                          className="ms-3 mt-3 me-3"
                          register={register("registerDate", {
                            required: true,
                          })}
                          placeholder="Please Enter here"
                        />
                        <FormErrorMessage
                          error={errors?.registerDate}
                          messages={{
                            required: "registerDate is Required",
                          }}
                        /> */}
                        <div className="col-12">
                          <label>Date:</label>
                          <div className="release_tentative_date">
                            <CustomController
                              name={"registerDate"}
                              control={control}
                              error={errors?.registerDate}
                              defaultValue={""}
                              rules={{ required: true }}
                              className={"msme_required_num_error"}
                              messages={{
                                required: "Register Date is Required",
                              }}
                              render={({ field: { onChange }, value, ...field }) => {
                                return (
                                  <CommonDatePicker
                                    clientDatePicker
                                    name="registerDate"
                                    {...field}
                                    id="date"
                                    value={inputfield?.registerDate}
                                    onChange={(date) => {
                                      const formattedDate = moment(date).format("MM-DD-YYYY");
                                      onChange(formattedDate);
                                      handleChange("registerDate", formattedDate);
                                    }}
                                    placeholder="Select Date"
                                    minDate={new Date()}
                                  />
                                );
                              }}
                            />
                          </div>
                        </div>
                      </p>
                    </div>
                  </div>

                  <div className="col-12 mt-2">
                    <div className="d-flex  ">
                      <div className="mb-5  me-4">
                        <CommonCheckBox
                          isChecked={isCheckedtwo}
                          name="agreetwo"
                          onChange={handleCheckBoxChangetwo}
                          errors={errors}
                          register={register("agreetwo", {
                            required: isCheckedtwo ? false : true,
                          })}
                        />
                        {!isCheckedtwo && (
                          <FormErrorMessage
                            error={errors?.agreetwo}
                            className="msme_required_error"
                            messages={{
                              required: "*Required",
                            }}
                          />
                        )}
                      </div>
                      <p className="m-0 px-2">
                        I/we declare that, information furnished above is true
                        and correct to the best of our knowledge and belief. In
                        case if there is any change in the information furnished
                        above, we will inform you accordingly.
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="col-12">
                    <div className="d-flex align-items-center ">
                      <div className="mb-5 me-4">
                        <CommonCheckBox
                          isChecked={isChecked}
                          name="agree"
                          onChange={handleCheckBoxChange}
                          errors={errors}
                          register={register("agree", {
                            required: isChecked ? false : true,
                          })}
                        />
                        {!isChecked && (
                          <FormErrorMessage
                            error={errors?.agree}
                            className="msme_required_error"
                            messages={{
                              required: "*Required",
                            }}
                          />
                        )}
                      </div>
                      <p className="m-0 px-2">
                        I/We, [ {name}] hereby affirm that currently we are NOT
                        REGISTERED ENTERPRISE under MSME Act. I/we further
                        assure that, if in future, we get registered under MSME
                        Act, we will inform you immediately.
                      </p>
                    </div>
                  </div>

                  <div className="col-12 mt-2">
                    <div className="d-flex align-items-center ">
                      <div className="mb-5 me-4">
                        <CommonCheckBox
                          isChecked={isCheckedtwo}
                          name="agreetwo"
                          onChange={handleCheckBoxChangetwo}
                          errors={errors}
                          register={register("agreetwo", {
                            required: isCheckedtwo ? false : true,
                          })}
                        />
                        {!isCheckedtwo && (
                          <FormErrorMessage
                            error={errors?.agreetwo}
                            className="msme_required_error"
                            messages={{
                              required: "*Required",
                            }}
                          />
                        )}
                      </div>
                      <p className="m-0 px-2">
                        DCCD I/we declare that, information furnished above is
                        true and correct to the best of our knowledge and
                        belief. In case if there is any change in the
                        information furnished above, we will inform you
                        accordingly.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            ""
          )}

          {msemscomapnay ? (
            loading ? (
              <div className="d-flex justify-content-center align-items-center mt-5">
                <UploadLoader />
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center mt-5 mb-3  col-6 ">

                <NormalButton
                  className="orderBtn text-uppercase changeco   "
                  label={" I Accept"}
                  onClick={handleSubmit(handleButtonClick)}
                />
              </div>
            )
          ) : (
            ""
          )}
        </div>
      </Modal>
    </>
  );
}
